import { useSelector } from 'react-redux';
import selectors from '../../redux/selectors/selectors';
import { Icon, PageWithLoading } from '../../shared/components';
import FloatingContactForm from '../../shared/components/FloatingContactForm';
import { StatusPageIdHttpJobsTable } from '../../features/status/http-job/status-page-id-http-jobs-table';
import { useParams } from 'react-router';
import { Button, Divider, notification, Select } from 'antd';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { get, post } from '../../redux/lib/api';
import { getStatusPageHttpJobs, getStatusPages } from '../../redux/actions/statusPageActions';
import { Content } from 'antd/es/layout/layout';
import BasicSlideOut from '../../shared/components/BasicSlideOut';
import useBoundForm from '../../shared/hooks/useBoundForm';
import BoundFormGroup from '../../shared/components/boundForm/BoundFormGroup';

const Container = styled.div``;

const Title = styled.div`
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 20px;
`;

const UrlContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #00122c;
  border-radius: 5px;
  border: 1px solid #06abc1;
  max-width: 50%;
  margin: 0 auto;
`;

const UrlHeader = styled.div`
  width: 100%;
  padding: 5px 10px;
  border-radius: 5px 5px 0 0;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  background-color: #001b3a;
`;

const UrlTextContainer = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  width: 100%;
`;

const UrlText = styled.span`
  flex-grow: 1;
  font-size: 14px;
  user-select: text;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;

  cursor: pointer;
  color: #06abc1;

  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export function StatusPageIdPage() {
  const { statusPageId: statusPageId } = useParams();
  const isInitializing = useSelector(selectors.isInitializing);
  const accountInfo = useSelector(selectors.accountInfo);
  const statusPages = useSelector(selectors.statusPages);
  const addForm = useBoundForm({});

  const [statusPageName, setStatusPageName] = useState(statusPageId);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addHttpJob, setAddHttpJob] = useState({});

  const [httpJobs, setHttpJobs] = useState([]);
  const [searchHttpJobs, setSearchHttpJobs] = useState('');
  const [searchingHttpJobs, setSearchingHttpJobs] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  const statusPageUrl = `https://statuspage.siteqwality.com/${accountInfo.id}/${statusPageId}`;

  const addStatusPage = () => {
    post(`status_page/${statusPageId}/http_job/${addHttpJob}`, {
      data: addForm.state,
    }).then((response) => {
      if (response) {
        notification.success({
          message: 'Success',
          description: 'Job added',
        });
      }
      getStatusPageHttpJobs(statusPageId).then(() => {
        setAddHttpJob('');
        setShowAddModal(false);
      });
    });
  };

  useEffect(() => {
    if (showAddModal) {
      let queryArgs = {
        limit: 5,
      };
      if (searchHttpJobs) {
        queryArgs['text'] = searchHttpJobs;
      }

      // Fetch http jobs
      setSearchingHttpJobs(true);
      get('http/jobs', {
        query: {
          limit: 5,
        },
      }).then((response) => {
        if (response) {
          setHttpJobs(response.jobs);
        }
        setSearchingHttpJobs(false);
      });
    } else {
      setSearchHttpJobs('');
    }
  }, [showAddModal]);

  useEffect(() => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        setSearchTimeout(null);

        let queryArgs = {
          limit: 5,
          text: searchHttpJobs,
        };

        setSearchingHttpJobs(true);
        get('http/jobs', { query: queryArgs }).then((response) => {
          if (response) {
            setHttpJobs(response.jobs);
          }
          setSearchingHttpJobs(false);
        });
      }, 500), // Delay of 500 milliseconds
    );
  }, [searchHttpJobs]);

  useEffect(() => {
    getStatusPages().then((_response) => {
      const statusPage = statusPages.find((page) => page.id === statusPageId);
      if (statusPage) {
        setStatusPageName(statusPage.friendly_name);
      }
    });
  }, []);

  const addFields = [
    [
      {
        id: 'friendly_name',
        label: 'Name',
        placeholder: 'Name',
      },
    ],
  ];

  return (
    <PageWithLoading isLoading={isInitializing}>
      <BasicSlideOut
        showSlideOut={showAddModal}
        hideSlideOut={() => setShowAddModal(false)}
        title="Add Monitor"
        body={
          <>
            <BoundFormGroup
              formId={addForm.id}
              fields={addFields}
            />
            <label
              style={{
                display: 'block',
                fontWeight: 'bold',
                marginBottom: '12px',
              }}>
              HTTP Site
            </label>
            <Select
              loading={searchingHttpJobs}
              showSearch={true}
              style={{
                width: '100%',
              }}
              placeholder="Search"
              onSearch={(value) => setSearchHttpJobs(value)}
              onSelect={(value, option) => {
                setAddHttpJob(option.data.id);
              }}
              filterSort={(optionA, optionB) => {
                return optionA.label.localeCompare(optionB.label);
              }}
              filterOption={(input, option) => {
                return option.data.friendly_name.toLowerCase().includes(input.toLowerCase());
              }}
              options={httpJobs.map((job) => ({
                value: job.id,
                label: job.friendly_name,
                data: job,
                key: job.id,
              }))}
              optionRender={(option) => {
                return (
                  <div>
                    {option.data.data.friendly_name} [{option.data.data.uri}]
                  </div>
                );
              }}
            />
          </>
        }
        submitText={'Add'}
        onSubmit={addStatusPage}
      />

      <Container>
        <Content>
          <Title>{statusPageName}</Title>
          <UrlContainer>
            <UrlHeader>View Your Status Page</UrlHeader>
            <UrlTextContainer>
              <UrlText>
                <a
                  href={statusPageUrl}
                  target={'_blank'}>
                  {statusPageUrl}
                </a>
              </UrlText>
            </UrlTextContainer>
          </UrlContainer>
        </Content>
      </Container>

      <Divider />

      <div style={{ display: 'flex', paddingBottom: 12, justifyContent: 'flex-end' }}>
        <Button
          onClick={() => {
            addForm.setState({});
            setShowAddModal(true);
          }}
          className="primary_big"
          icon={
            <Icon
              name="plus"
              size={12}
            />
          }>
          Add Montior
        </Button>
      </div>

      <StatusPageIdHttpJobsTable statusPageId={statusPageId} />
      <FloatingContactForm />
    </PageWithLoading>
  );
}
